const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.offsetHeight}px`,
    )

    this.setAttribute('loaded', '')

    this.setupDropdown()
    this.setupScrollListener()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.offsetHeight}px`,
    )
  }

  setupDropdown () {
    if (!this.els['dropdown-trigger']?.element || !this.els.dropdown?.element) {
      return
    }

    this.isDropdownOpen = false
    this.dropdownTrigger = this.els['dropdown-trigger'].element
    this.dropdown = this.els.dropdown.element

    this.dropdown.setAttribute('aria-hidden', 'true')

    this.els['dropdown-trigger'].elements.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleDropdown())
    })

    if (
      this.els['dropdown-slides']?.element &&
      this.els['dropdown-slide']?.elements
    ) {
      this.dropdownCarousel = this.setupDropdownCarousel()
    } else {
      this.setDropdownHeight()
      this.debouncedSetDropdownHeight = debounce(
        () => this.setDropdownHeight(),
        250,
      )
      window.addEventListener('resize', this.debouncedSetDropdownHeight)
    }
  }

  setDropdownHeight () {
    if (!this.els.body?.element) return

    const bodyHeight = this.els.body.element.offsetHeight
    this.dropdown.style.setProperty(
      '--dropdown-height',
      `calc(100svh - ${bodyHeight}px)`,
    )
  }

  setupDropdownCarousel () {
    return new KeenSlider(this.els['dropdown-slides'].element, {
      selector: this.els['dropdown-slide'].selector,
      defaultAnimation: {
        duration: 1500,
      },
      loop: false,
      mode: 'snap',
      slides: {
        perView: 1.1,
        spacing: 15,
      },
      breakpoints: {
        '(min-width: 768px)': {
          disabled: true,
        },
      },
    })
  }

  setupScrollListener () {
    this.lastScrollY = window.scrollY
    this.scrollThreshold = 50

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const currentScrollY = window.scrollY

    if (
      currentScrollY > this.scrollThreshold &&
      currentScrollY > this.lastScrollY
    ) {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false
        this.closeDropdown()
      }
    }

    this.lastScrollY = currentScrollY
  }

  toggleDropdown () {
    this.isDropdownOpen = !this.isDropdownOpen

    if (this.isDropdownOpen) {
      this.openDropdown()
    } else {
      this.closeDropdown()
    }
  }

  openDropdown () {
    this.dropdown.setAttribute('aria-hidden', 'false')
    this.dropdownTrigger.setAttribute('aria-expanded', 'true')

    this.els['close-text'].element.setAttribute('aria-hidden', 'false')

    this.autoplayPlugin.instance().pause()

    requestAnimationFrame(() => {
      const dropdownHeight = this.els['dropdown-body']?.element.scrollHeight
      document.body.style.setProperty(
        '--Dropdown_Height',
        `${dropdownHeight}px`,
      )
    })
  }

  closeDropdown () {
    this.dropdown.setAttribute('aria-hidden', 'true')
    this.dropdownTrigger.setAttribute('aria-expanded', 'false')

    this.els['close-text'].element.setAttribute('aria-hidden', 'true')

    this.autoplayPlugin.instance().resume()

    // Remove dropdown height from body
    document.body.style.removeProperty('--Dropdown_Height')
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)
    this.autoplayPlugin = useAutoplay(4, { pauseOnHover: true })

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [this.autoplayPlugin],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
